module.exports = __webpack_public_path__ + "static/media/Re-Placeholder.07801235.png";